import { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
import List from 'components/List'
import Filters from 'components/Filters'
import { AiOutlineSearch } from 'react-icons/ai'
import { GiDiamondTrophy } from 'react-icons/gi'
import { GiSmartphone } from 'react-icons/gi'
import { GiPiggyBank } from 'react-icons/gi'
import { GiClockwork } from 'react-icons/gi'
import { GiModernCity } from 'react-icons/gi'
import { GiFactory } from 'react-icons/gi'
import { device } from '../breakpoints'
import { GiLightBulb } from 'react-icons/gi'
import { GiShakingHands } from 'react-icons/gi'
import { GiAbstract086 } from 'react-icons/gi'
import { BiSlider } from 'react-icons/bi'
import ScrollUpButton from 'components/ScrollUpButton'
import { VscClose } from 'react-icons/vsc'
import { GiBed } from 'react-icons/gi'
import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
interface ListProps {
  data: any
  onYearChange: (year: string) => void
  year: number
}

const sectorsIcons: { [key: string]: ReactElement } = {
  Technologie: <GiLightBulb />,
  Luxe: <GiDiamondTrophy />,
  Digital: <GiSmartphone />,
  Services: <GiShakingHands />,
  Industrie: <GiFactory />,
  Immobilier: <GiModernCity />,
  Finance: <GiPiggyBank />,
  Horlogerie: <GiClockwork />,
  'Hôtellerie restauration': <GiBed />,
}

const sectors = [
  'Technologies',
  'Industrie',
  'Finance',
  'Immobilier',
  'Services',
  'Digital',
]

const ExampleComponent: FC<ListProps> = ({
  data,
  onYearChange,
  year,
}): ReactElement => {
  const [ref, setRef] = useState<HTMLElement | null>(null)
  const [textSearch, setTextSearch] = useState<string | null>(null)
  const [textValue, setTextValue] = useState<string>('')
  const [filters, setFilters] = useState<any>(new Map())
  const [searchRef, setSearchRef] = useState<HTMLDivElement | null>(null)
  const [showFilters, setShowFilters] = useState<boolean>(false)

  // All the items
  const items = data

  // Make an array of the data grouped by mainSector
  const groupedItems = items.reduce((acc: any, item: any) => {
    const key = item.mainSector
    if (!acc[key]) {
      acc[key] = []
    }
    acc[key].push(item)
    return acc
  }, {})

  // Get the filtered items if there are filters
  const filteredItems =
    filters.size > 0
      ? items.filter((item: any) => {
          // The data used to filter the items
          const itemFilterData: { [key: string]: any } = {
            age: item.age,
            location: item.location,
            sector: item.mainSector,
          }

          // For each filter, check if the item's data matches the filter
          return [...filters.keys()].every((filterType: string) => {
            // Get the filter value
            const filterValue = filters.get(filterType)

            // Special case for age
            if (filterType === 'age') {
              const [min, max] = [filterValue, filterValue + 5]
              return (
                itemFilterData[filterType] >= min &&
                itemFilterData[filterType] <= max
              )
            }

            // Check if this filter contains the item's value for this key
            let isInFilters = filterValue === itemFilterData[filterType]

            return isInFilters
          })
        })
      : items

  // Filter the items by the text search
  const outputItems = textSearch
    ? filteredItems.filter((item: any) => {
        return [item.text, item.mainSector, item.businessName, item.name]
          .join(' ')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .includes(
            textSearch
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
          )
      })
    : filteredItems

  // useEffect(() => {
  //   // If the MF is not in the viewport, scroll to it
  //   if (ref && selectedId) {
  //     if (ref.getBoundingClientRect().top > 0) {
  //       ref.scrollIntoView({ behavior: 'smooth', block: 'start' })
  //     } else if (ref.getBoundingClientRect().bottom < window.innerHeight) {
  //       ref.scrollIntoView({ behavior: 'smooth', block: 'end' })
  //     }
  //   }

  //   if (selectedId) {
  //     console.log('Freeze body')
  //     //document.body.style.overflow = 'hidden !important'
  //     //document.body.style.borderTop = '1px solid red'
  //     //document.body.style.overflowY = 'hidden'
  //     document.body.style.setProperty("overflow", "hidden", "important")
  //     document.body.style.setProperty("height", "100%")
  //   } else {
  //     console.log('Unfreeze body')
  //     //document.body.style.overflow = 'auto'
  //     //document.body.style.borderTop = '0'
  //     //document.body.style.overflowY = 'auto'
  //     document.body.style.setProperty("overflow", "visible")
  //     document.body.style.setProperty("height", "auto")
  //   }
  // }, [selectedId, ref])

  // useEffect(() => {
  //   setSelectedId(urlParam)
  // }, [])

  return (
    <Container ref={setRef}>
      <ScrollUpButton anchorRef={searchRef} mainRef={ref} forceHide={false} />
      <SearchContainer ref={setSearchRef}>
        <TextWidth style={{ marginBottom: 20 }}>
          <TextSearchContainer>
            <TextSearch
              value={textValue}
              onKeyDown={(e) => {
                e.key === 'Enter' && (e.target as HTMLTextAreaElement).blur()
              }}
              placeholder='Que recherchez-vous?'
              type='text'
              onChange={(e) => {
                const val = e.target.value
                setTextValue(val)
                if (val.length > 2) {
                  setTextSearch(val)
                } else {
                  setTextSearch(null)
                }
              }}
            />
            {textValue.length > 0 && (
              <ResetIcon
                onClick={() => {
                  setTextValue('')
                  setTextSearch(null)
                }}
              >
                <VscClose />
              </ResetIcon>
            )}
            <SearchIcon>
              <AiOutlineSearch />
            </SearchIcon>
          </TextSearchContainer>
          <FiltersButton
            onClick={() => {
              setShowFilters(!showFilters)
            }}
          >
            <BiSlider /> <FilterText>Filtres</FilterText>
          </FiltersButton>
        </TextWidth>

        <YearContainer>
          Édition
          <Select>
            <select value={year} onChange={(e) => onYearChange(e.target.value)}>
              <option value='2024'>2024</option>
              <option value='2025'>2025</option>
              <option value='2026'>2026</option>
            </select>
            <MdOutlineKeyboardArrowDown />
          </Select>
        </YearContainer>

        {showFilters && (
          <ContentWidth style={{ padding: 0 }}>
            <Filters
              data={items}
              onFilterChange={(filters: any) => {
                setFilters(filters)
              }}
            />
          </ContentWidth>
        )}
      </SearchContainer>

      <ContentWidth>
        <Content>
          {filters.size > 0 || textSearch ? (
            <>
              <FiltersResult>
                {outputItems.length > 0 ? (
                  <>
                    <strong>{`${outputItems.length} fiche${
                      outputItems.length > 1 ? 's' : ''
                    }`}</strong>
                    &nbsp;correspond{outputItems.length > 1 ? 'ent' : ''} à vos
                    critères.
                  </>
                ) : (
                  `Aucun résultat`
                )}
              </FiltersResult>
              <List
                data={outputItems.sort((a: any, b: any) =>
                  a.lastName.localeCompare(b.lastName, 'fr-CH', {
                    sensitivity: 'base',
                    ignorePunctuation: true,
                  })
                )}
              />
            </>
          ) : (
            Object.keys(groupedItems)
              .sort(
                (a: any, b: any) =>
                  sectors.indexOf(a.mainSector) - sectors.indexOf(b.mainSector)
              )
              .map((group: any) => (
                <div key={`group-${group}`}>
                  <SectorTitle>
                    <SectorIcon>
                      {sectorsIcons[group] ? (
                        sectorsIcons[group]
                      ) : (
                        <GiAbstract086 />
                      )}
                    </SectorIcon>
                    {group}
                  </SectorTitle>
                  <List
                    data={groupedItems[group].sort((a: any, b: any) =>
                      a.lastName.localeCompare(b.lastName, 'fr-CH', {
                        sensitivity: 'base',
                        ignorePunctuation: true,
                      })
                    )}
                  />
                </div>
              ))
          )}
        </Content>
      </ContentWidth>
    </Container>
  )
}
const Container = styled.div`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

const Content = styled.div``

const ResetIcon = styled.div`
  font-size: 2.25rem;
  color: var(--brandblue-main);
  display: flex;
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
`

const FiltersButton = styled.div`
  background-color: ${({ theme }) => theme.mainColor};
  color: white;
  font-family: var(--font-sans-serif);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  white-space: nowrap;
  cursor: pointer;
  line-height: 1;
  margin-left: 15px;
`

const FilterText = styled.div`
  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    display: none;
    margin-left: 0;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    display: block;
    margin-left: 10px;
  }
`

const TextSearch = styled.input`
  border-radius: 0;
  padding: 15px;
  border: 0;
  width: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.siteBackground};
  outline: none;
  -webkit-appearance: none;
  font-size: 1.6rem;
  font-family: var(--font-sans-serif);
  color: ${({ theme }) => theme.textColor};
  margin: 0;
`

const SectorTitle = styled.div`
  font-family: var(--font-sans-serif);
  font-weight: 200;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 30px;
  padding-top: 20px;
  line-height: 1;
  color: ${({ theme }) => theme.textColor};

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 3rem;
    margin-top: 30px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 4rem;
    margin-top: 60px;
  }
`

const SearchContainer = styled.div`
  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 15px;
    padding-top: 60px;
    padding-bottom: 0;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 30px;
    padding-top: 60px;
    padding-bottom: 0;
  }
`

const FiltersResult = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.45rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem auto 3rem auto;
  width: 100%;
  font-weight: 300;
  color: ${({ theme }) => theme.textColor};
`

const SectorIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 10px;
  display: block;
  color: ${({ theme }) => theme.mainColor};
`

const TextSearchContainer = styled.div`
  font-family: var(--font-sans-serif);
  font-weight: 700;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  border-bottom: 2px solid ${({ theme }) => theme.textColor};
  background-color: #eaeaea;
  flex: 1;
`

const SearchIcon = styled.div`
  font-size: 2.25rem;
  color: var(--brandblue-main);
  display: flex;
  align-items: center;
  padding: 0 15px;
`

const TextWidth = styled.div`
  max-width: 800px;
  margin: 0 auto;
  display: flex;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 0;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 0;
  }
`

const ContentWidth = styled.div`
  max-width: 1260px;
  margin: 0 auto;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 0 10px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 0 20px;
  }
`

const YearContainer = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1em;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.textColor};
  -webkit-font-smoothing: antialiased;
  max-width: 800px;
  margin: 0 auto;
  justify-content: flex-start;
  margin-bottom: 20px;

  select {
    font-family: var(--font-sans-serif);
    font-size: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    color: white;
    border: 0;
    outline: none;
    padding: 0 6px;
    margin: 0;
    cursor: pointer;
    appearance: none;
  }
`

const Select = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.mainColor};
  color: white;
  border: 0;
  outline: none;
  padding: 0;
  margin: 0;
  padding: 3px;
  border-radius: 5px;
  margin-left: 10px;

  option {
    background-color: white;
    color: #333;
  }
`

export default ExampleComponent
